import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IPassengerDetailPassengerAttributes extends IModelAttributes {
	passengerDetailId: string;
	passengerId: string;

	passengerDetail: Models.PassengerDetailEntity | Models.IPassengerDetailEntityAttributes;
	passenger: Models.PassengerEntity | Models.IPassengerEntityAttributes;
}

@entity('PassengerDetailPassenger')
export default class PassengerDetailPassenger extends Model implements IPassengerDetailPassengerAttributes {
	@observable
	@attribute()
	public passengerDetailId: string;

	@observable
	@attribute()
	public passengerId: string;

	@observable
	@attribute({ isReference: true })
	public passengerDetail: Models.PassengerDetailEntity;

	@observable
	@attribute({ isReference: true })
	public passenger: Models.PassengerEntity;

	constructor(attributes?: Partial<IPassengerDetailPassengerAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.passengerDetailId) {
				this.passengerDetailId = attributes.passengerDetailId;
			}
			if (attributes.passengerId) {
				this.passengerId = attributes.passengerId;
			}

			if (attributes.passengerDetail) {
				if (attributes.passengerDetail instanceof Models.PassengerDetailEntity) {
					this.passengerDetail = attributes.passengerDetail;
					this.passengerDetailId = attributes.passengerDetail.id;
				} else {
					this.passengerDetail = new Models.PassengerDetailEntity(attributes.passengerDetail);
					this.passengerDetailId = this.passengerDetail.id;
				}
			} else if (attributes.passengerDetailId !== undefined) {
				this.passengerDetailId = attributes.passengerDetailId;
			}

			if (attributes.passenger) {
				if (attributes.passenger instanceof Models.PassengerEntity) {
					this.passenger = attributes.passenger;
					this.passengerId = attributes.passenger.id;
				} else {
					this.passenger = new Models.PassengerEntity(attributes.passenger);
					this.passengerId = this.passenger.id;
				}
			} else if (attributes.passengerId !== undefined) {
				this.passengerId = attributes.passengerId;
			}
		}
	}
}
